import { render, staticRenderFns } from "./GlossarySearch.vue?vue&type=template&id=724ff0e2"
import script from "./GlossarySearch.vue?vue&type=script&lang=js"
export * from "./GlossarySearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports